module.exports = __webpack_public_path__ + "static/media/alerces.396cc2be.webp";